import * as Yup from 'yup';

const isEmptyField = (title?: string): Yup.StringSchema =>
  Yup.string().required(`${title || ''} is required field!`);

export default isEmptyField;
